export default "__VITE_ASSET__CCqcxHWF__"